import useRealtimeDocument from './use-realtime-document';
import type { IEPGResponse } from 'models';

export const useIsChannelLive = (id: string) => {
  const [epg] = useRealtimeDocument<IEPGResponse>('epg', id);

  return Boolean(epg?.asset?.live);
};
